module.exports = "<div class=\"preloader-backdrop\">\r\n    <div class=\"page-preloader\">Loading</div>\r\n</div>\r\n<router-outlet></router-outlet>\r\n<div class=\"sidenav-backdrop backdrop\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/app.component.html
// module id = ./ClientApp/app/app.component.html
// module chunks = main